const handler = function () {
    let options = {
        area: null,
        login_url: null,
        token: null,
        user: null,
    };

    this.setOptions = o => {
        options = o;
    }

    this.getLoginUrl = () => {
        return options.login_url;
    }

    this.getToken = () => {
        return options.token;
    }

    this.getIdentity = () => {
        return options.user;
    }
}

const SSO = new handler()

export default SSO
